import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_TYPE_REPORT_COLUMNS} from '../../utils'
import CustomerTypeReportRow from './CustomerTypeReportRow'
import {parseCustomerTypeReportRow} from '../../parsings'
import CustomerTypeReportsHeader from '../header/CustomerTypeReportsHeader'
import { formatPrice } from '../../../../utils/common'

const CustomerTypeReportTable = () => {
  const {
    customerTypeData,
    isCustomerTypeLoading,
    onCustomerTypeSortingChange,
    customerTypeFilters,
  } = useContext(CustomerReportContext)

  return (
    <div className='card border'>
      <div className='card-body p-7'>
        <CustomerTypeReportsHeader />
        <DynamicTable
          data={customerTypeData}
          sortableColumns={CUSTOMER_TYPE_REPORT_COLUMNS}
          loading={isCustomerTypeLoading}
          TableRow={CustomerTypeReportRow}
          noDataMessage='No customer type reports found'
          filters={customerTypeFilters}
          onSortingChange={onCustomerTypeSortingChange}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerTypeReportRow}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals.total_order_count}</td>
                <td>{formatPrice(columnTotals.total_discount, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerTypeReportTable
